module.exports = __webpack_public_path__ + "img/dark-s_nz.a36b443f.jpg";